import { cn } from '@heroui/react'

const LoadingData = ({
  title,
  description,
  className,
}: {
  title: string
  description: string
  className?: string
}) => {
  return (
    <div
      className={cn(
        'flex h-[calc(100vh-180px)] mx-[30px] flex-col justify-center items-center  dark:bg-[#1A1A1A] bg-gray-100 rounded-lg border dark:border-[#2A2A2A] border-[#ddd]',
        className,
      )}
    >
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mb-4" />
      <h3 className="text-lg font-medium dark:text-white text-black mb-2">{title}</h3>
      <p className="text-sm dark:text-[#AFAFAF] text-black">{description}</p>
    </div>
  )
}

export default LoadingData
